// extracted by mini-css-extract-plugin
export default {"coursesPageContainer":"coursesPage_coursesPageContainer__gnanF","showProduct":"coursesPage_showProduct__xk6If"};